/**
 * The Partners container
 */
import { env } from "@bkry/bowline-utils";
import { ScrollToTop as useScrollToTop } from "@bkry/bowline-components/Utils";
import PropTypes from "prop-types";
import React from "react";
import ReactPlayer from "react-player";
import { Container } from "reactstrap";
import ArtistsIntro from "../components/ArtistsIntro";
import Page from "../components/Page/Page-component";
import SectionWithModal from "../components/SectionWithModal";
import {
  ledgerArray,
  wiamiArray,
  illuviumArray,
  wowArray,
  belvedereArray,
  polygonlabsArray,
} from "../components/utils/PartnerModalImageArray";
const { REACT_APP_CDN_PATH } = env;

/**
 * Partners container, the landing page for logged in users
 */
const Partners = (props, context) => {
  useScrollToTop();
  const partners = [
    {
      id: 1,
      subtitle: context.t("partners.ledger.subtitle"),
      title: context.t("partners.ledger.title"),
      text: context.t("partners.ledger.description"),
      image:
        "/images/gen3rator/prices/500x500_Benefits_DETAILS_Ledger_Nano_X_Neu.png",
      modal: {
        subHeader: context.t("partners.ledger.modal.subHeader"),
        headline: context.t("partners.ledger.modal.headline"),
        text: context.t("partners.ledger.modal.text"),
        items: ledgerArray,
        twitter: "https://twitter.com/Ledger",
        // insta: "https://www.instagram.com/xxx/?hl=de",
        // youtube: "https://www.youtube.com/@xxx",
        // discord: "https://discord.com/invite/xxx",
        // linkedin: "https://au.linkedin.com/company/xxx",
        // tiktok: "https://www.tiktok.com/@xxx",
        // twitch: "https://www.twitch.tv/xxx",
        // telegram: "https://t.me/xxx",
        // medium: "",
        opensea: "https://opensea.io/collection/inspired-by-ledger",
        link: context.t("partners.ledger.link"),
      },
    },
    {
      id: 2,
      subtitle: context.t("partners.wiami.subtitle"),
      title: context.t("partners.wiami.title"),
      text: context.t("partners.wiami.description"),
      image: "/images/collabs/Partnerpage_750x720_WW.png",
      modal: {
        subHeader: context.t("partners.wiami.modal.subHeader"),
        headline: context.t("partners.wiami.modal.headline"),
        text: context.t("partners.wiami.modal.text"),
        items: wiamiArray,
        twitter: "https://twitter.com/WilderWorld",
        insta: "https://www.instagram.com/wilder.world/",
        youtube: "https://www.youtube.com/@WilderWorld",
        discord: "https://discord.gg/wilderworld",
        // linkedin: "https://au.linkedin.com/company/xxx",
        // tiktok: "https://www.tiktok.com/@xxx",
        // twitch: "https://www.twitch.tv/xxx",
        telegram: "https://t.me/wilder_world",
        // medium: "",
        opensea: "https://opensea.io/collection/wilderworld",
        link: context.t("partners.wiami.link"),
      },
    },
    {
      id: 3,
      subtitle: context.t("partners.illuvium.subtitle"),
      title: context.t("partners.illuvium.title"),
      text: context.t("partners.illuvium.description"),
      image: "/images/collabs/Partnerpage_750x720_Illuvium.png",
      modal: {
        subHeader: context.t("partners.illuvium.modal.subHeader"),
        headline: context.t("partners.illuvium.modal.headline"),
        text: context.t("partners.illuvium.modal.text"),
        items: illuviumArray,
        twitter: "https://twitter.com/illuviumio",
        // insta: "https://www.instagram.com/xxx/?hl=de",
        // youtube: "https://www.youtube.com/@xxx",
        discord: "https://discord.com/invite/illuvium",
        linkedin: "https://au.linkedin.com/company/illuvium-io",
        tiktok: "https://www.tiktok.com/@illuviumio",
        twitch: "https://www.twitch.tv/illuviumio",
        // telegram: "https://t.me/xxx",
        // medium: "",
        // opensea: "https://opensea.io/collection/xxx",
        link: context.t("partners.illuvium.link"),
      },
    },
    {
      id: 4,
      subtitle: context.t("partners.wow.subtitle"),
      title: context.t("partners.wow.title"),
      text: context.t("partners.wow.description"),
      image: "/images/collabs/Partnerpage_801x800_WOW3.png",
      modal: {
        subHeader: context.t("partners.wow.modal.subHeader"),
        headline: context.t("partners.wow.modal.headline"),
        text: context.t("partners.wow.modal.text"),
        items: wowArray,
        twitter: "https://twitter.com/worldofwomennft",
        insta: "https://www.instagram.com/worldofwomen/",
        // youtube: "https://www.youtube.com/@xxx",
        discord: "https://discord.com/invite/worldofwomen",
        linkedin: "https://www.linkedin.com/company/worldofwomennft",
        // tiktok: "https://www.tiktok.com/@xxx",
        // twitch: "https://www.twitch.tv/xxx",
        // telegram: "https://t.me/xxx",
        medium: "https://news.worldofwomen.art/",
        opensea: "https://opensea.io/collection/world-of-women-nft",
        link: context.t("partners.wow.link"),
      },
    },
    {
      id: 5,
      subtitle: context.t("partners.belvedere.subtitle"),
      title: context.t("partners.belvedere.title"),
      text: context.t("partners.belvedere.description"),
      image: "/images/collabs/Partnerpage_600x600_Belvedere.png",
      modal: {
        subHeader: context.t("partners.belvedere.modal.subHeader"),
        headline: context.t("partners.belvedere.modal.headline"),
        text: context.t("partners.belvedere.modal.text"),
        items: belvedereArray,
        // twitter: "https://twitter.com/xxx",
        // insta: "https://www.instagram.com/xxx/?hl=de",
        // youtube: "https://www.youtube.com/@xxx",
        // discord: "https://discord.com/invite/xxx",
        // linkedin: "https://au.linkedin.com/company/xxx",
        // tiktok: "https://www.tiktok.com/@xxx",
        // twitch: "https://www.twitch.tv/xxx",
        // telegram: "https://t.me/xxx",
        medium: "https://thekissnft.medium.com/",
        opensea:
          "https://opensea.io/collection/belvedere-arteq-the-kiss-by-gustav-klimt",
        link: context.t("partners.belvedere.link"),
      },
    },
    {
      id: 6,
      subtitle: context.t("partners.polygonlabs.subtitle"),
      title: context.t("partners.polygonlabs.title"),
      text: context.t("partners.polygonlabs.description"),
      image: "/images/collabs/Partnerpage_Polygon.png",
      modal: {
        subHeader: context.t("partners.polygonlabs.modal.subHeader"),
        headline: context.t("partners.polygonlabs.modal.headline"),
        text: context.t("partners.polygonlabs.modal.text"),
        items: polygonlabsArray,
        twitter: "https://twitter.com/0xPolygon",
        insta: "https://www.instagram.com/0xpolygon/",
        youtube: "https://www.youtube.com/PolygonTV",
        discord: "https://discord.com/invite/0xPolygon",
        linkedin: "https://www.linkedin.com/company/polygonlabs/",
        // tiktok: "https://www.tiktok.com/@xxx",
        // twitch: "https://www.twitch.tv/xxx",
        // telegram: "https://t.me/xxx",
        // medium: "",
        // opensea: "https://opensea.io/collection/xxx",
        link: context.t("partners.polygonlabs.link"),
      },
    },
  ];
  return (
    <Page id="artist" title="Web3 Collabs">
      <div className="d-flex justify-content-center">
        <ReactPlayer
          url={(REACT_APP_CDN_PATH || "") + "/videos/collabs/gen3_partner.mp4"}
          controls={true}
          playing={true}
          playsinline
          muted={true}
          loop={true}
          width="100%"
          height="auto"
          fallback={
            (REACT_APP_CDN_PATH || "") +
            "/images/collabs/Partnerpage_1920x1080_Samsung_Slice.png"
          }
        />
      </div>
      <Container className="pb-5">
        <ArtistsIntro
          subtitle={context.t("partners.intro.subtitle")}
          title={context.t("partners.intro.title")}
          smallText={context.t("partners.intro.smallText")}
          bigText={context.t("partners.intro.bigText")}
        />
        {partners.map((section) => (
          <SectionWithModal section={section} key={section.id} />
        ))}
      </Container>
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
Partners.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default Partners;
